import { useState } from 'react';
import PetszelLearnMoreModal from '../Modal/PetszelLearnMoreModal';
import { useTranslation } from '../../hooks/useTranslation';
import { TranslationKeyEnum } from '../../types/constants';
import {
  Button,
  ButtonSize,
  ButtonType,
  IconButton,
  IconButtonSize,
  IconButtonVariant,
  IconName,
} from '@hills-design-system/components';
import { BoltIcon } from '../icons';

interface PetszelReportingBannerProps {
  className?: string;
  isDismissable?: boolean;
  isPermananentVisible?: boolean;
}

const PetszelReportingBanner: React.FC<PetszelReportingBannerProps> = ({
  className = '',
  isDismissable = true,
  isPermananentVisible = false,
}) => {
  // Check localStorage when initializing state
  const [isVisible, setIsVisible] = useState(() => {
    if (isPermananentVisible) return true;
    const storedVisibility = localStorage.getItem('petszelBannerVisible');
    return storedVisibility === null ? true : storedVisibility === 'true';
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();

  // Update localStorage when visibility changes
  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('petszelBannerVisible', 'false');
  };

  if (!isVisible) return null;

  return (
    <>
      <div
        className={`relative font-sans bg-[#EDF2F8] rounded-[16px] p-6 md:p-8 flex flex-col gap-2 ${className}`}
      >
        <div className="flex flex-row justify-between w-full gap-2">
          {/* Badge */}
          <div>
            <span className="text-accent-primary-text-grass bg-accent-primary-icon-grass text-sm font-bold px-3 py-1 rounded-2xl mb-3">
              {t(TranslationKeyEnum.NewLabel)}
            </span>
          </div>

          {/* Dismiss Button */}
          {isDismissable && (
            <IconButton
              variant={IconButtonVariant.Tertiary}
              size={IconButtonSize.Medium}
              icon={IconName.X}
              onClick={handleDismiss}
            />
          )}
        </div>

        <div className="flex flex-row justify-between items-end gap-2">
          <div>
            {/* Title with Bolt Icon */}
            <div className="flex items-center gap-2">
              <BoltIcon width={10} height={15} />
              <h3 className="text-xl font-bold">{t(TranslationKeyEnum.AutomateHillsReporting)}</h3>
            </div>

            {/* Subtext */}
            <p className="font-normal text-black text-md">
              {t(TranslationKeyEnum.PetszelDisabledBannerDescription)}
            </p>
          </div>
          {/* Action Button */}
          <div className="flex-shrink-0 mt-2 md:mt-0">
            <Button
              label={t(TranslationKeyEnum.LearnMore)}
              type={ButtonType.Primary}
              size={ButtonSize.Small}
              onClick={() => setIsModalOpen(true)}
            />
          </div>
        </div>
      </div>

      {isModalOpen && (
        <PetszelLearnMoreModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      )}
    </>
  );
};

export default PetszelReportingBanner;
